/**
 * 用户行为分析API服务
 */

import axios from 'axios'

const API_BASE_URL = '/api/v1/assessments'

/**
 * 获取用户分析统计数据
 * @param {string} statMonth - 统计月份（YYYY-MM-DD格式）
 * @param {number} loginThreshold - 登录次数阈值
 * @param {number} orderThreshold - 下单次数阈值
 * @returns {Promise<Object>} 统计数据
 */
export const getUserAnalyzeStats = async (statMonth, loginThreshold, orderThreshold) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/userAnalyze`, {
      params: {
        statMonth,
        loginThreshold,
        orderThreshold
      },
      headers: {
        'Authorization': localStorage.getItem('token') || ''
      }
    })

    if (response.data.code === '200') {
      return {
        success: true,
        data: response.data.data
      }
    } else {
      throw new Error(response.data.info || '获取统计数据失败')
    }
  } catch (error) {
    console.error('获取用户分析统计数据失败:', error)
    return {
      success: false,
      error: error.response?.data?.info || error.message || '获取统计数据失败'
    }
  }
}

// /**
//  * 获取用户行为详细数据（为图表组件提供数据）
//  * @param {string} statMonth - 统计月份
//  * @param {number} loginThreshold - 登录次数阈值
//  * @param {number} orderThreshold - 下单次数阈值
//  * @returns {Promise<Object>} 详细行为数据
//  */
// export const getUserBehaviorDetails = async (statMonth, loginThreshold, orderThreshold) => {
//   // TODO: 后续如果需要详细的用户行为数据可以添加对应的后端接口
//   // 目前先返回模拟数据结构
//   return {
//     success: true,
//     data: {
//       scatterData: [], // 散点图数据 [[loginCount, orderCount, userId], ...]
//       barData: {       // 柱状图数据
//         categories: [],
//         loginData: [],
//         orderData: []
//       },
//       userTableData: [], // 用户表格数据
//       inactiveIds: []    // 非活跃用户ID列表
//     }
//   }
// }
export const searchUsers = async keyword => {
  try{
    const {data} = await axios.get(`${API_BASE_URL}/search`, {
      params: { keyword },
      headers: { 'Authorization': localStorage.getItem('token') || ''}
    })
    if(data.code === '200'){
      return {
        success: true,
        data: data.data
      }
    } else {
      throw new Error(data.info || '搜索用户失败')
    }
  }catch(e){
      console.error('搜索用户失败:', e)
      return []
  }
}

/**
 * 获取指定用户的行为趋势数据（最近12个月）
 * @param {number} userId - 用户ID
 * @param {string} endMonth - 结束月份（可选，YYYY-MM-DD格式）
 * @returns {Promise<Object>} 用户趋势数据
 */
export const getUserTrend = async (userId, endMonth) => {
  try {
    const params = { userId }
    if (endMonth) {
      params.endMonth = endMonth
    }
    
    const response = await axios.get(`${API_BASE_URL}/trend`, {
      params,
      headers: {
        'Authorization': localStorage.getItem('token') || ''
      }
    })
    
    if (response.data.code === '200') {
      return {
        success: true,
        data: response.data.data
      }
    } else {
      throw new Error(response.data.info || '获取用户趋势数据失败')
    }
  } catch (error) {
    console.error('获取用户趋势数据失败:', error)
    return {
      success: false,
      error: error.response?.data?.info || error.message || '获取用户趋势数据失败'
    }
  }
}

/**
 * 获取所有非管理员用户ID列表（按ID升序排列）
 * @returns {Promise<Object>} 用户ID列表
 */
export const getAllNonAdminUserIds = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/userIds`, {
      headers: {
        'Authorization': localStorage.getItem('token') || ''
      }
    })
    
    if (response.data.code === '200') {
      return {
        success: true,
        data: response.data.data
      }
    } else {
      throw new Error(response.data.info || '获取用户ID列表失败')
    }
  } catch (error) {
    console.error('获取用户ID列表失败:', error)
    return {
      success: false,
      error: error.response?.data?.info || error.message || '获取用户ID列表失败'
    }
  }
}

export default {
  getUserAnalyzeStats,
  searchUsers,
  getUserTrend,
  getAllNonAdminUserIds,
  // getUserBehaviorDetails
}
